export default __webpack_public_path__ + "static/media/1st-blog.e005b88b.jpg";